module.exports = __webpack_public_path__ + "static/media/oreidy-crest.c181d563.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/icons/oreidy-crest.svg
// module id = 355
// module chunks = 0